import {
  Backdrop,
  Box,
  CircularProgress,
  InputAdornment,
  Typography,
} from "@mui/material";
import {
  SectionTitle,
  StyledOneChildContainer,
  StyledParentContainer,
  StyledTwoChildContainer,
} from "../../StyledComponents/Container";
import Grid from "@mui/material/Grid2";
import CustomTextFieldComponent from "../../../../shared/CustomTextFeild";
import ContainedButton from "../../../../shared/Button/CustomContainedButton";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import OutlinedButton from "../../../../shared/Button/customOutlinedButton";
import { useTranslation } from "react-i18next";
import EditIcon from "@mui/icons-material/Edit";
import CancelPopUp from "../../../PopUp/PopUp";
import SubmitPopUp from "../../../PopUp/PopUp";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/store";
import * as constants from "../../../../constants";
import { saveNewCreditLineDetails } from "../../services/CreditLine/CreditLineServices";
import { notifyUser } from "../../Utils/notifyUser";
import CustomTextField from "../../../../shared/CustomTextFeild";
import { NumericFormat } from "react-number-format";
import { getClientDetailsByClientName } from "../../Utils/ClientSettingsTable";

const NewDetailsSubmit = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const userInfo = useSelector((state: RootState) => state.auth);
  const ClientDetails = getClientDetailsByClientName(userInfo?.clientVo?.name);
  const { t } = useTranslation();
  const translate = t as (key: string) => string;

  const [openCancelPopUp, setOpenCancelPopUp] = useState(false);
  const [openSubmitPopup, setSubmitPopup] = useState(false);
  const [fromData, setFormData] = useState(location.state);
  const [isLoading, setIsLoading] = useState(false);

  const handleCancel = () => {
    setOpenCancelPopUp(true);
  };
  const handlePopUpClose = () => {
    setOpenCancelPopUp(false);
  };
  function handleCancelConfirm() {
    navigate("/creditLineSummaryListing");
  }

  const handleSubmit = () => {
    setSubmitPopup(true);
  };
  const handleSubmitPopUpClose = () => {
    setSubmitPopup(false);
  };
  const handleSubmitConfirm = async () => {
    setSubmitPopup(false);
    try {
      const saveVo = {
        name: fromData.name,
        projectNumber: fromData.projectNumber,
        projectDuration: fromData.projectTerm,
        interestRate: fromData.interestRate,
        amount: fromData.amount,
        description: fromData.description,
        type: fromData.sourceOfFund,
        status: constants.IS_Status_ACTIVE,
        availableCredit: fromData.amount,
        participantId: userInfo.defaultParticipantId,
        clientId: userInfo.clientId,
        createdBy: userInfo.emailId,
        lastUpdatedBy: userInfo.emailId,
        creditlineTransactionHistory: [
          {
            amount: 0,
            availableCredit: fromData.amount,
            description: "New Credit Line initiated",
            glCategory: "Liabilities",
            transactionType: "CR",
            createdBy: userInfo.emailId,
            lastUpdatedBy: userInfo.emailId,
          },
        ],
      };

      const response = await saveNewCreditLineDetails(saveVo);
      if (response.status === constants.STATUS_CODES.CREATED) {
        const message = response.data.message;
        navigate("/creditLineSummaryListing", { state: { message: message } });
      } else {
        notifyUser(
          response.response.data.message,
          "error",
          translate("review&Submit")
        );
      }
    } catch (error) {
      console.error("Error saving CreditLines details:", error);
    } finally {
      setIsLoading(false);
    }
  };
  function handleBackClick() {
    navigate("/newCreditLine", { state: fromData });
  }

  return (
    <StyledParentContainer>
      <StyledOneChildContainer>
        <StyledTwoChildContainer sx={{ border: "none" }}>
          <SectionTitle>
            {translate("reviewAndSubmit")} &nbsp;
            <EditIcon onClick={handleBackClick} sx={{ cursor: "pointer" }} />
          </SectionTitle>
          <StyledTwoChildContainer>
            <Box sx={{ width: "100%", padding: "40px" }}>
              <Grid container spacing={2} direction={"column"}>
                <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                  <CustomTextFieldComponent
                    labelText={translate("creditLineType")}
                    value={fromData.sourceOfFund}
                    readOnly={true}
                  />
                </Grid>
                <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                  <CustomTextFieldComponent
                    labelText={translate("name")}
                    name="name"
                    value={fromData.name}
                    readOnly={true}
                  />
                </Grid>
               {ClientDetails?.newCreditLineProjectNumber === constants.IS_ACTIVE_YES && ( <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                  <CustomTextFieldComponent
                    labelText={translate("projectNumber")}
                    name="projectNumber"
                    value={fromData.projectNumber}
                    readOnly={true}
                  />
                </Grid>)}
                <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                  <CustomTextFieldComponent
                    labelText={translate("projectTerm")}
                    name="projectTerm"
                    value={fromData.projectTerm}
                    readOnly={true}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          {translate("month")}
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                  <NumericFormat
                    customInput={CustomTextField}
                    id="credit-amount"
                    thousandSeparator
                    decimalScale={2}
                    fixedDecimalScale
                    labelText={translate("amount")}
                    value={fromData.amount || 0}
                    allowNegative={false}
                    readOnly
                    prefix="$"
                  />
                </Grid>
                <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                  <NumericFormat
                    customInput={CustomTextField}
                    id="interest-rate"
                    decimalScale={2}
                    readOnly
                    labelText={translate("interestRate(APR)")}
                    allowNegative={false}
                    value={fromData.interestRate || 0}
                    suffix="%"
                  />
                </Grid>
                <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                  <CustomTextFieldComponent
                    labelText={translate("enterDescription")}
                    name="description"
                    multiline
                    rows={4}
                    value={fromData.description}
                    readOnly={true}
                  />
                </Grid>
              </Grid>
            </Box>
          </StyledTwoChildContainer>
          <div className="right-fields" style={{ marginTop: "10px" }}>
            <ContainedButton sx={{ mr: 2 }} onClick={handleSubmit}>
              {translate("submit")}
            </ContainedButton>
            <ContainedButton sx={{ mr: 2 }} onClick={handleBackClick}>
              {translate("back")}
            </ContainedButton>
            <OutlinedButton onClick={handleCancel}>
              {translate("cancel")}
            </OutlinedButton>
          </div>
          <Backdrop
            sx={(theme) => ({
              color: "#fff",
              zIndex: theme.zIndex.drawer + 1,
              display: "flex",
              flexDirection: "column",
            })}
            open={isLoading}
          >
            <CircularProgress color="inherit" />
            <Typography color="white">Please wait...</Typography>
          </Backdrop>
          <SubmitPopUp
            open={openSubmitPopup}
            popupTitle={translate("confirmSubmit")}
            handleClose={handleSubmitPopUpClose}
            saveChanges={() => handleSubmitConfirm()}
            message={translate("doYouWantToSubmitChanges?")}
          />
          <CancelPopUp
            open={openCancelPopUp}
            popupTitle={translate("confirmCancel")}
            handleClose={handlePopUpClose}
            saveChanges={() => handleCancelConfirm()}
            message={translate("doYouWantToCancelChanges?")}
          />
        </StyledTwoChildContainer>
      </StyledOneChildContainer>
    </StyledParentContainer>
  );
};
export default NewDetailsSubmit;
